<template>
  <div>
    <o-table ref="tableList"
             :enable-delete="user && !!user.is_super_user"
             :enable-edit="hasPermission(['POST api/sandoz/educational/contracts/{id}'])"
             :enable-new="hasPermission(['POST api/sandoz/educational/contracts/{id}'])"
             :title="$t('sandoz.educational_contracts')"
             default-sort-by="id"
             default-sort-by-direction="desc"
             :edit-route="dynRoute"
             url="/api/sandoz/educational/contracts"
    >
      <template slot="filter">
        <o-filter :filter-cacheable="true" v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)">
          <o-filter-text :title="$t('sandoz.contract_no')" column="contract_no"></o-filter-text>
          <o-filter-text :title="$t('sandoz.customer_external_id')" column="customer_external_id"></o-filter-text>
          <o-filter-text :title="$t('sandoz.responsible_sales_person')"
                         column="responsible_sales_person"></o-filter-text>
          <o-filter-select :items="status" :title="$t('sandoz.status')" column="status"></o-filter-select>
          <o-filter-select :items="years" :title="$t('sandoz.contract_year')" column="contract_year"></o-filter-select>
          <o-filter-checkbox :items="previousContract" :title="$t('sandoz.has_previous_contract')"
                             column="no_previous_contract"></o-filter-checkbox>
          <o-filter-select :items="types" :title="$t('sandoz.contract_type')" column="type"></o-filter-select>
          <o-filter-text :title="$t('sandoz.company_name')" column="company_name"></o-filter-text>
          <o-filter-text :title="$t('sandoz.name')" column="name"></o-filter-text>
          <o-filter-text :placeholder="$t('sandoz.street_zip_city')" :title="$t('sandoz.address')"
                         column="address"></o-filter-text>
        </o-filter>
      </template>
      <template slot="head">
        <o-table-header column="contract_no">{{ $t('sandoz.contract_no') }}</o-table-header>
        <o-table-header column="customer_external_id">{{ $t('sandoz.customer_external_id') }}</o-table-header>
        <o-table-header :sortable="false">{{ $t('sandoz.company_name') }}</o-table-header>
        <o-table-header column="responsible_sales_person">{{ $t('sandoz.responsible_sales_person') }}</o-table-header>
        <o-table-header :sortable="false">{{ $t('sandoz.next_approver_role') }}</o-table-header>
        <o-table-header column="status">{{ $t('sandoz.status') }}</o-table-header>
      </template>
      <template slot="body" slot-scope="props">
        <td>{{ props.item.contract_no }}</td>
        <td>{{ props.item.customer_external_id }}</td>
        <td>{{ props.item.company_name }}</td>
        <td>{{ props.item.responsible_sales_person }}</td>
        <td>
          <template v-if="props.item.is_approved">
            <template v-if="props.item.next_approver">
              {{ $t('sandoz.approved') }}
              <a href="javascript:void(0);" @click="openApproverModal(props.item)">
                <fa class="text-success" icon="info-circle"></fa>
              </a>
            </template>
          </template>
          <template v-else-if="props.item.status !== 'Cancelled'">
            {{ props.item.next_approver_role }}
            <a v-if="props.item.next_approver_role" href="javascript:void(0);" @click="openApproverModal(props.item)">
              <fa icon="info-circle"></fa>
            </a>
          </template>
        </td>
        <td>
            <span v-if="props.item.status == 'Feedback' || props.item.status == 'Rejected'" class="text-danger">
              {{ $t('sandoz.' + props.item.status.match(/[A-Z][a-z]+/g).join("_").toLowerCase()) }}
              <fa icon="info-circle" @click.prevent="showFeedback(props.item)"></fa>
            </span>
          <span v-else>
              {{ $t('sandoz.' + props.item.status.match(/[A-Z][a-z]+/g).join("_").toLowerCase()) }}
            </span>
        </td>
      </template>
    </o-table>

    <approver-modal ref="approverModal" :contract="contract"/>
  </div>
</template>


<script>
import {mapGetters} from 'vuex'
import ApproverModal from '../partials/ApproverModal.vue'
import {contractYears} from '../../../utils/contractYear'
import { dynamicContractRoute } from '../../../utils/dynamicContractRoute'

export default {
  components: {
    ApproverModal
  },
  data: () => ({
    status: [],
    years: [],
    types: [],
    previousContract: [],
    contract: null
  }),
  created() {
    this.years = contractYears()

    this.status = [
      {value: 'Planned', text: this.$i18n.t('sandoz.planned')},
      {value: 'Draft', text: this.$i18n.t('sandoz.draft')},
      {value: 'Committed', text: this.$i18n.t('sandoz.committed')},
      {value: 'Signed', text: this.$i18n.t('sandoz.signed')},
      {value: 'Lost', text: this.$i18n.t('sandoz.lost')},
      {value: 'Cancelled', text: this.$i18n.t('sandoz.cancelled')},
      {value: 'ZeroInvest', text: this.$i18n.t('sandoz.zero_invest')},
      {value: 'Feedback', text: this.$i18n.t('sandoz.feedback')},
      {value: 'Rejected', text: this.$i18n.t('sandoz.rejected')},
      {value: 'Approved', text: this.$i18n.t('sandoz.approved')},
      {value: 'Invoice Release Pending', text: this.$i18n.t('sandoz.invoice_release_pending')}
    ]
    this.previousContract = [
      {value: 'Yes', text: this.$i18n.t('sandoz.yes')},
      {value: 'No', text: this.$i18n.t('sandoz.no')}
    ]

    this.types = [
      {value: 'SD_EDU', text: this.$i18n.t('sandoz.sd_edu')},
      {value: 'CNS_EDU', text: this.$i18n.t('sandoz.cns_edu')},
      {value: 'IMMUNO_EDU', text: this.$i18n.t('sandoz.immuno_edu')},
      {value: 'ONCO_EDU', text: this.$i18n.t('sandoz.onco_edu')},
      {value: 'KAM_SD_EDU', text: this.$i18n.t('sandoz.kam_sd_edu')},
      {value: 'APO_EDU', text: this.$i18n.t('sandoz.apo_edu')},
      {value: 'KAM_APO_EDU', text: this.$i18n.t('sandoz.kam_apo_edu')}
    ]
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },
  methods: {
    dynRoute(item) {
      return dynamicContractRoute(this, item)
    },
    hasPermission(item) {
      let result = true
      let permissions = item
      let user = this.user
      if (!user.is_super_user && permissions) {
        permissions.forEach((permission) => {
          if (!user.routePermissions.includes(permission)) {
            result = false
          }
        })
      }
      return result
    },
    openApproverModal(contract) {
      this.contract = contract
      this.$refs.approverModal.showDialog()
    },
    showFeedback(item) {
      window.alert(item.approval_feedback)
    },
    closeApproverModal() {
      this.contract = null
      this.$refs.approverModal.hideDialog()
    },
  }
}
</script>
